import { createApp } from "vue";
import App from "./App.vue";
import store from "./store/index.js";
import route from "./config/route.js";
import loadingDirective from "./components/loading/loading";
import Vue3ColorPicker from "vue3-colorpicker";
import "vue3-colorpicker/style.css";
import { ElConfigProvider } from 'element-plus'

// 引入全局样式文件
import "./assets/css/style.css";


createApp(App)
  .use(store)
  .use(route)
  .use(Vue3ColorPicker)
  .directive("loading", loadingDirective)
  .component('el-config-provider', ElConfigProvider)
  .mount("#app")
